namespace TabAurous.Production {
    export interface DismantlingForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        TermsId: Serenity.IntegerEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: DismantlingItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class DismantlingForm extends Serenity.PrefixedContext {
        static formKey = 'Production.Dismantling';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DismantlingForm.init)  {
                DismantlingForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.ImageUploadEditor;
                var w8 = DismantlingItemsEditor;

                Q.initFormType(DismantlingForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'AutoPosting', w4,
                    'TermsId', w3,
                    'CurrencyId', w5,
                    'ExchRate', w6,
                    'UserId', w5,
                    'EmployeeId', w3,
                    'ProductItemImage', w7,
                    'ItemDetails', w8,
                    'FinancialYearId', w3,
                    'Pieces', w3,
                    'Weight', w6,
                    'NetWeight', w6,
                    'NetAmount', w6,
                    'Discount', w6,
                    'AdditionalCharges', w6,
                    'GrossAmount', w6,
                    'Remark', w2,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
